export const RialticRoles = {
    content: 'Content@rialtic',
    design: 'Design@rialtic',
    engCore: 'Engineering-Core-Claims@rialtic',
    engCloud: 'Engineering-Cloud@rialtic',
    engEngines: 'Engineering-Engines@rialtic',
    engWorkflows: 'Engineering-Workflows@rialtic',
    cs: 'Client-Success@rialtic',
    gtm: 'GTM@rialtic',
    product: 'Product@rialtic',
};
export const RialticEngineering = [
    RialticRoles.engCore,
    RialticRoles.engCloud,
    RialticRoles.engEngines,
    RialticRoles.engWorkflows,
];
export var Permissions;
(function (Permissions) {
    Permissions["readConfig"] = "read:config";
    Permissions["writeConfig"] = "write:config";
    Permissions["readSystem"] = "read:system";
    Permissions["writeSystem"] = "write:system";
    Permissions["writeTeamContent"] = "write:team-content";
    Permissions["readTeamContent"] = "read:team-content";
    Permissions["readUsersAll"] = "read:users-all";
    Permissions["writeUsersAll"] = "write:users-all";
    Permissions["readWorkspacesAll"] = "read:workspaces-all";
    Permissions["writeWorkspacesAll"] = "write:workspaces-all";
})(Permissions || (Permissions = {}));
export var WorkspacePermissions;
(function (WorkspacePermissions) {
    WorkspacePermissions["readAnalytics"] = "workspace:workspaceId#read:analytics";
    WorkspacePermissions["readPhi"] = "workspace:workspaceId#read:phi";
    WorkspacePermissions["readConnectors"] = "workspace:workspaceId#read:connector";
    WorkspacePermissions["writeConnectors"] = "workspace:workspaceId#write:connector";
    WorkspacePermissions["readConnectorConfig"] = "workspace:workspaceId#read:connector-config";
    WorkspacePermissions["writeConnectorConfig"] = "workspace:workspaceId#write:connector-config";
    WorkspacePermissions["readSystem"] = "workspace:workspaceId#read:system";
    WorkspacePermissions["writeSystem"] = "workspace:workspaceId#write:system";
    WorkspacePermissions["readUsers"] = "workspace:workspaceId#read:users";
    WorkspacePermissions["writeUsers"] = "workspace:workspaceId#write:users";
    WorkspacePermissions["readWorkspace"] = "workspace:workspaceId#read:workspace";
    WorkspacePermissions["writeWorkspace"] = "workspace:workspaceId#write:workspace";
})(WorkspacePermissions || (WorkspacePermissions = {}));
const guard = (rule, endpointChecks, userProps) => {
    if (!userProps || !userProps.length) {
        return false;
    }
    if (rule === 'ALL') {
        return endpointChecks.every((p) => userProps.includes(p));
    }
    return endpointChecks.some((p) => userProps.includes(p));
};
export const rolesGuard = ({ roles, rule, userRoles }) => {
    if (guard(rule, roles, userRoles)) {
        return true;
    }
    throw new Error('missing role');
};
export const permissionsGuard = ({ permissions, userPermissions, rule, }) => {
    if (!userPermissions) {
        throw new Error('no permissions');
    }
    if (guard(rule, permissions, userPermissions)) {
        return true;
    }
    console.log('action denied');
    console.log('USER_PERMISSIONS', userPermissions);
    console.log('PERMISSIONS', permissions);
    throw new Error('missing permission');
};
export const workspacePermissionsGuard = ({ workspaceId, userPermissions, permissions, rialticPermissions, rule, }) => {
    if (!workspaceId) {
        throw new Error('workspace id required');
    }
    if (rialticPermissions?.length) {
        const pass = permissionsGuard({
            rule,
            permissions: rialticPermissions,
            userPermissions,
        });
        if (pass) {
            return true;
        }
    }
    const userWorkspacePermissions = userPermissions?.filter((p) => p.startsWith('workspace:'));
    if (!userWorkspacePermissions?.length) {
        throw new Error('no workspace permissions');
    }
    const endpointPermissions = permissions.map((p) => {
        const [, scope] = p.split('#');
        return `workspace:${workspaceId}#${scope}`;
    });
    console.log('action denied');
    console.log('USER_WORKSPACE_PERMISSIONS', userWorkspacePermissions);
    console.log('ENDPOINT_PERMISSIONS', endpointPermissions);
    if (guard(rule, endpointPermissions, userWorkspacePermissions)) {
        return true;
    }
    throw new Error(`missing workspace permission, user permissions: ${Array.isArray(userWorkspacePermissions)
        ? JSON.stringify(userWorkspacePermissions)
        : userWorkspacePermissions}`);
};
//# sourceMappingURL=authorization.js.map